import { HttpType, apiInternetBase, openLoading } from "gf-ui";

class apiQuestionario extends apiInternetBase {
    constructor(dispatch, apiCallback, token){
        super(dispatch, apiCallback, token, "questionario")
    }

    #init           = (token, cb)             => this._getJson(HttpType.POST, `/init-web`, cb, token);
    #getDomande     = (token, cb)             => this._getJson(HttpType.POST, `/domande`, cb, token);
    #salvaRisposte  = (token, cb)             => this._getJson(HttpType.POST, `/salva`, cb, token);
    #termina        = (token, idScheda, cb)   => this._getJson(HttpType.POST, `/${idScheda}/termina`, cb, token);
    #lingue         = (token, idTipologia, cb)=> this._getJson(HttpType.POST, `/modello/${idTipologia}/lingue`, cb, token);    
    #stampa         = (token, cb)             => this._getJson(HttpType.POST, `/stampa`, cb, token);    

    fnInit = (fnReturn, fnError) => {
      openLoading(this.dispatch);      
      this.#init(this.token, (status, res) => this.apiCallback(status, res, fnReturn, fnError))
    }

    fnGetDomande = (fnReturn, params, fnError) => {
      openLoading(this.dispatch);
      this.setParams(params)
      this.#getDomande(this.token, (status, res) => this.apiCallback(status, res, fnReturn, fnError))
    }

    fnSalvaRisposte = (fnReturn, params, fnError) => {
      openLoading(this.dispatch);
      this.setParams(params)
      this.#salvaRisposte(this.token, (status, res) => this.apiCallback(status, res, fnReturn, fnError))
    }

    fnTermina = (idScheda, fnReturn, params, fnError) => {
      openLoading(this.dispatch);
      this.setParams(params)
      this.#termina(this.token, idScheda, (status, res) => this.apiCallback(status, res, fnReturn, fnError))
    }

    fnLingue = (idTipologia, fnReturn, params, fnError) => {
      openLoading(this.dispatch);
      this.setParams(params)
      this.#lingue(this.token, idTipologia, (status, res) => this.apiCallback(status, res, fnReturn, fnError))
    }    

    fnStampa = (fnReturn, params, fnError) => {
      openLoading(this.dispatch);
      this.setParams(params)
      this.#stampa(this.token, fnReturn)
    }    
}

export default apiQuestionario;
